import React from 'react';
import { Modal, Typography, Button } from '@material-ui/core';
import { stylesSaveData } from './stylesSaveData';


const SaveData = ({ open, onClose, success }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{...stylesSaveData.modal}}
        >
            <div style={{...stylesSaveData.paper}}>
                <Typography variant="h6">
                    {success ? 'Los cambios se guardaron con éxito' : 'Hubo un error al guardar los cambios'}
                </Typography>
                <Button onClick={onClose} color="primary" variant="contained" style={{ marginTop: '16px' }}>
                    Cerrar
                </Button>
            </div>
        </Modal>
    );
};

export default SaveData;
